import styled from 'styled-components';


export const BlogRouteContainer = styled.div`
    width: 100vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    // overflow-x: hidden;
    overflow-y: auto;

`;

export const BlogContainer = styled.div`
    width: 100%;
    height: auto;
    background-color: rgba(000, 000, 000, 0.2);
    align-self: center;
    display: flex;
    flex-direction: column;
    position: relative;
    bottom: 0%;
    // overflow-y: auto;
    // overflow-x: hidden;

    header {
        background-color: #f8f9fa; /* Default color */
        color: #333;
        padding: 20px;
        position: sticky;
        top: 0;
        z-index: 1000;
        transition: background-color 0.3s ease;
      }
      
      header.blue {
        background-color: #007bff; /* Blue color */
        color: #fff;
      }
      
      header.black {
        background-color: #000; /* Black color */
      }

    .head-tripple-box {
        display: flex;
        flex-direction: column;
    }
`;
